import {
  isFeatureEnabled,
  isPresentationResetAfterTurnOnFlag,
  comparePresentationCreatedDateWithFlag,
} from '../featureToggles.module'

const reactionActions = {
  canGetReactionFromAhaSyncForPresentation: ({ rootGetters }, presentation) => {
    const livestatsFlag = 'kv-sync-emqx-for-live-stats'
    return isFeatureEnabled(rootGetters, livestatsFlag)
            && (isPresentationResetAfterTurnOnFlag(presentation, livestatsFlag)
            || comparePresentationCreatedDateWithFlag(presentation, livestatsFlag))
  },
}

export default reactionActions
